// extracted by mini-css-extract-plugin
module.exports = {"toast":"style_toast__yGSXt","buttonWrapper":"style_buttonWrapper__P0b+Y","copyWrapper":"style_copyWrapper__m+f6Y","input":"style_input__f5D-1","button":"style_button__NBcdl"};